<template>
  <div>

    <Card :class-header="{'pt-3': true}" :class-body="{'text-align-center': !hasSubcompanies }">

      <div slot="header" class="row mb-2">
        <div class="col-md-2 company-title">
          <h5><strong>Filiais desta empresa</strong></h5>
        </div>

        <div v-if="$withPolicy('application', 'companies/insert_or_update')" class="col-md-10">
            <button
                class="btn btn-primary float-right"
                @click="showModalUpload = true"
            >
              Upload arquivo modelo
            </button>

          <button
              class="btn btn-outline mr-2 float-right"
              @click="linkDownloadTemplate"
          >
            Download arquivo modelo
          </button>
        </div>
      </div>

      <template v-if="!hasSubcompanies">
        <div class="row mt-4 mb-4">
          <div class="col-md-12">
            <input v-model="query.generic" class="input form-control"
                   @keypress.enter="find()"
                   placeholder="Pesquisar por: Nome ou CNPJ">
            <search-icon @click="find()" class="icon icon-within"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h5><strong>Não foi encontrada nenhuma filial cadastrada</strong></h5>
          </div>
        </div>
        <div class="row" v-if="$withPolicy('application', 'companies/insert_or_update')">
          <div class="col-md-12">
            <button
                class="btn btn-primary btn-lg"
                @click="createSubcompany()"
            >
              Adicionar
            </button>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="row">
          <div class="col-md-12">

            <button v-if="$withPolicy('application', 'companies/insert_or_update')"
                    class="btn btn-primary btn-lg"
                    @click="createSubcompany()">
              Adicionar Filial
            </button>

            <div class="row mt-4">
              <div class="col-md-12">
                <input v-model="query.generic" class="input form-control"
                       @keypress.enter="find()"
                       placeholder="Pesquisar por: Nome ou CNPJ">
                <search-icon @click="find()" class="icon icon-within"/>
              </div>
            </div>

            <Table
              :subsidiaries="subcompanies"
              @sendSubsidiaryToEdit="editSubcompany"
              @sendSubsidiaryToDelete="sendSubcompanyToDelete"
            />

            <div class="row">
              <div class="col-md-12 my-1">
                <Pagination
                  v-model="params.page"
                  :total-count="meta.totalCount"
                  :total-pages="meta.totalPages"
                  @pagination="pagination"
                />
              </div>
            </div>

          </div>
        </div>
      </template>

    </Card>

    <ModalDeleteCompany v-model="showModalDelete"
                        v-if="currentSubsidiary"
                        @deleteCompany="deleteSubcompany"
                        :company="currentSubsidiary"/>

    <Modal v-model="showModalForm">
      <span slot="header">{{ titleModalForm }}</span>

      <Form :company="currentSubsidiary"
            @saveCompany="saveSubcompany"
            @cancel="showModalForm = false"/>
    </Modal>

    <Modal v-model="showModalUpload">
      <Upload :isMultiple="false" accept=".csv, .CSV" @changeFiles="changeFiles">
        <h5>Clique para selecionar ou arraste o arquivo CSV</h5>
      </Upload>
    </Modal>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'
  import Card from '@/components/company/subcompany/Card'
  import Table from '@/components/company/subcompany/Table'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModalDeleteCompany from '@/components/company/subcompany/ModalDeleteCompany'
  import Modal from '@/components/shares/specialTag/Modal'
  import Form from '@/components/company/subcompany/Form'
  import Upload from '@/components/shares/specialTag/Upload'
  import { SearchIcon } from 'vue-feather-icons'
  import GetAccount from '@/mixins/GetAccount.vue';

  export default {
    components: { Card, Form, Modal, ModalDeleteCompany, Pagination, SearchIcon, Table, Upload },
    computed: {
      hasSubcompanies() {
        return this.subcompanies.length > 0
      },
      subcompanies() {
        return this.getModels || []
      },
    },
    created() {
      this.query.company_id = this.parentCompany.id
      this.find()
    },
    data() {
      return {
        currentSubsidiary: {},
        load: false,
        nameModel: 'Company',
        notifyMessages: [],
        notifyType: '',
        showModalDelete: false,
        showModalForm: false,
        showModalUpload: false,
        titleModalForm: ''
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      changeFiles(files) {
        const formData = new FormData()
        formData.append('file', files[0])

        this.axios.post('companies/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => this.$notify.add('Arquivo exportado com sucesso!'))
          .catch(e => this.$notify.addError(e))
          .finally(() => {
            this.showModalUpload = false
            this.find()
          })
      },
      createSubcompany() {
        this.titleModalForm = 'Cadastrar nova filial'
        this.showModalForm = true
      },
      deleteSubcompany(subcompany) {
        this.asyncTemplateDelete(subcompany, {
          after: () => {
            this.showModalDelete = false
            this.find()
          }
        })
      },
      editSubcompany(subcompany) {
        this.currentSubsidiary = subcompany
        this.titleModalForm = 'Editar filial'
        this.showModalForm = true
      },
      find() {
        this.asyncTemplateSelect()
      },
      linkDownloadTemplate() {
        this.axios.get('companies/template_file/subsidiary', { responseType: 'blob'})
            .then(blob => this.$parse.buildDownload('Template - Cadastro de filiais.csv', blob))
      },
      saveSubcompany(subcompany) {
        subcompany.company_id = this.parentCompany.id
        this.load = true

        this.asyncTemplateSave(subcompany, {
          after: () => {
            this.showModalForm = false
            this.find()
          }
        })
      },
      sendSubcompanyToDelete(subcompany) {
        this.currentSubsidiary = subcompany
        this.showModalDelete = true
      }
    },
    mixins: [ModelMapper, GetAccount],
    name: 'Subsidiary',
    props: {
      parentCompany: { required: true, type: Object },
    }
  }
</script>

<style scoped>
  .company-title {
    margin-top: 10px;
  }
  .card {
    height: 100%;
  }

  p {
    color: var(--primary-text-color);
  }

  .table td {
    vertical-align: middle;
  }
</style>
